// extracted by mini-css-extract-plugin
module.exports = {"qrCodeWrapper":"Import_qrCodeWrapper__1wNqb","qrCode":"Import_qrCode__3ZVKd"};